const conditionEventList = {
    bindings: {
      selection: '<',
      settings: '<',
      criteria: '<',
      filters: '<',
      area: '<',
      gridlet: '<',
    },
    templateUrl: '/modules/gridlets/condition-event-list/condition-event-list.html',
    controller: 'ConditionEventListController',
  };
  
  angular
    .module('gridlets.module')
    .component('conditionEventList', conditionEventList);